import {TFunction} from 'i18next';
import {ContentSelectOption, MultiRadioStyled} from '../styled';
import {OPTION_VALUES} from '../utils';
import {useTranslation} from 'react-i18next';
import {RadioOptionType} from 'components/common/MultiRadio';
import {useLocation} from 'react-router-dom';

const getRadioOptions = (t: TFunction) => [
  {label: `${t('booking_reference')}`, value: OPTION_VALUES.booking_reference},
  {
    label: `${t('chekin_in_date_and_email')}`,
    value: OPTION_VALUES.check_in_date_and_email,
  },
];

type Props = {
  value?: RadioOptionType;
  onChange: (value: RadioOptionType) => void;
};

export const SearchOptions = ({value, onChange}: Props) => {
  const {t} = useTranslation();
  const {state} = useLocation();

  return (
    <ContentSelectOption>
      <MultiRadioStyled
        className="multi-radio__option"
        options={getRadioOptions(t)}
        onChange={onChange}
        value={value}
        defaultValue={state?.mode}
        isCustomBox
      />
    </ContentSelectOption>
  );
};
